import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faHouse, faSun, faMoon } from "@fortawesome/free-solid-svg-icons"
import { useNavigate, useLocation } from 'react-router-dom'
import useAuth from "../hooks/useAuth"
import { useEffect, useState } from "react"
import Cookie from "./Cookie"

const DashFooter = () => {

    // theme settings, using cookies
    // default to dark
    const [theme, setTheme] = useState(localStorage.getItem('theme') || 'dark');
    const [icon, setIcon] = useState(theme==='dark' ? faSun : faMoon )
    const [iconText, setIconText]=useState(theme==='dark' ? 'Set light Theme' : 'Set Dark Theme' )

    useEffect(() => {
      document.documentElement.setAttribute('data-bs-theme', theme);
      localStorage.setItem('theme', theme);
    }, [theme]);

    const toggleTheme = () => {
        setTheme(theme === 'light' ? 'dark' : 'light');
        if (theme === 'light') {
            setIcon(faSun)
            setIconText('Set Light Theme')
        } else {
            setIcon(faMoon)
            setIconText('Set Dark Theme')
        }
    };




    const { username } = useAuth()
    const navigate = useNavigate()
    const { pathname } = useLocation()

    const onGoHomeClicked = () => navigate('/dash')

    let goHomeButton = null
    if (pathname !== '/dash') {
        goHomeButton = (
            <span
                className="p-2 icon"
                style={{marginRight:"10px"}}
                title="Go Home"
                role="button"
                onClick={onGoHomeClicked}
            >
                <FontAwesomeIcon icon={faHouse} />
            </span>
        )
    }

    const content = (
        <footer id="main_footer">
            <div className="row">
                <div className="col-md-12 text-end">
                    <span
                        role="button"
                        className="icon"
                        title={iconText}
                        onClick={toggleTheme}
                        style={{float:'left'}}
                    >
                    <FontAwesomeIcon icon={icon} className="fa-icon" />
                    </span>
                    {goHomeButton}
                    Welcome {username} |<i style={{fontSize: "0.7em"}}>Version6.16d</i>             
                </div>
            </div>
            <Cookie />
        </footer>
    )
    return content
}
export default DashFooter